import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { LeagueDto } from '../../../models/dtos/league.dto';
import { Errors } from '../../errors';
import getLeaguesRequest from './getLeagues.repository';

type InitialState = {
  loading: boolean;
  data?: LeagueDto[];
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getLeagues = createAsyncThunk('getLeagues', async () => {
  return await getLeaguesRequest();
});

const getLeaguesSlice = createSlice({
  name: 'getLeagues',
  initialState,
  reducers: {
    getLeaguesReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLeagues.pending, (state) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    });
    builder.addCase(
      getLeagues.fulfilled,
      (state, action: PayloadAction<LeagueDto[]>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getLeagues.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default getLeaguesSlice.reducer;
export const { getLeaguesReset } = getLeaguesSlice.actions;
